// Software We Use — real logos served via simpleicons.org CDN where available.
// For proprietary CAD/survey vendors not on simpleicons, we use lettermark badges
// rendered by the SoftwareCard component (passing `lettermark: 'BC'` etc.).
//
// Icon URL pattern: https://cdn.simpleicons.org/<slug>/<hex-color>
// (Returns a clean color-tinted SVG; no auth required.)

export const softwareCategories = [
  {
    id: 'cad',
    title: 'CAD & Drafting',
    desc: 'Industry-standard 2D/3D CAD platforms our drafters work in daily.',
    items: [
      { name: 'AutoCAD', icon: 'https://cdn.simpleicons.org/autodesk/E51937', color: '#E51937' },
      { name: 'AutoCAD LT', icon: 'https://cdn.simpleicons.org/autodesk/E51937', color: '#E51937' },
      { name: 'Civil 3D', icon: 'https://cdn.simpleicons.org/autodesk/0696D7', color: '#0696D7' },
      { name: 'BricsCAD', lettermark: 'BC', color: '#E60028' },
      { name: 'ProgeCAD', lettermark: 'PC', color: '#1E70B8' },
      { name: 'IntelliCAD', lettermark: 'IC', color: '#0F4C81' },
      { name: 'Carlson', lettermark: 'CN', color: '#005B96' },
      { name: 'MicroStation', icon: 'https://cdn.simpleicons.org/bentley/14B5EA', color: '#14B5EA' },
      { name: 'DraftSight', lettermark: 'DS', color: '#005386' },
      { name: 'ZWCAD', lettermark: 'ZW', color: '#0F62FE' },
    ],
  },
  {
    id: 'bim',
    title: 'BIM Software',
    desc: 'Building Information Modeling tools for clash detection, coordination, and 4D/5D modeling.',
    items: [
      { name: 'Revit', icon: 'https://cdn.simpleicons.org/autodesk/0696D7', color: '#0696D7' },
      { name: 'Navisworks', icon: 'https://cdn.simpleicons.org/autodesk/F47821', color: '#F47821' },
      { name: 'ArchiCAD', icon: 'https://cdn.simpleicons.org/graphite/0078D4', color: '#0078D4' },
      { name: 'Tekla Structures', lettermark: 'TK', color: '#0073E6' },
      { name: 'AECOsim', lettermark: 'AE', color: '#14B5EA' },
      { name: 'OpenBuildings', icon: 'https://cdn.simpleicons.org/bentley/14B5EA', color: '#14B5EA' },
      { name: 'Solibri', lettermark: 'SB', color: '#00A551' },
      { name: 'Vectorworks', lettermark: 'VW', color: '#1E3A8A' },
    ],
  },
  {
    id: 'gis',
    title: 'GIS & Survey',
    desc: 'Geospatial mapping and survey processing platforms for accurate location intelligence.',
    items: [
      { name: 'ArcGIS', icon: 'https://cdn.simpleicons.org/esri/247BA0', color: '#247BA0' },
      { name: 'QGIS', icon: 'https://cdn.simpleicons.org/qgis/589632', color: '#589632' },
      { name: 'Trimble Business Center', lettermark: 'TB', color: '#005A2C' },
      { name: 'Leica Infinity', lettermark: 'LI', color: '#FFD100' },
      { name: 'Terramodel', lettermark: 'TM', color: '#7B3F00' },
      { name: 'TopoDOT', lettermark: 'TD', color: '#FF6B00' },
      { name: 'Global Mapper', icon: 'https://cdn.simpleicons.org/openstreetmap/7EBC6F', color: '#7EBC6F' },
      { name: 'MAGNET Office', lettermark: 'MO', color: '#003D7A' },
    ],
  },
  {
    id: '3d',
    title: '3D Modeling & Visualization',
    desc: 'Rendering, animation, and immersive visualization tools for photorealistic deliverables.',
    items: [
      { name: '3ds Max', icon: 'https://cdn.simpleicons.org/autodesk/00A8E1', color: '#00A8E1' },
      { name: 'Maya', icon: 'https://cdn.simpleicons.org/autodesk/00A8E1', color: '#00A8E1' },
      { name: 'SketchUp', icon: 'https://cdn.simpleicons.org/sketchup/005F9E', color: '#005F9E' },
      { name: 'Rhino 3D', icon: 'https://cdn.simpleicons.org/rhinoceros/801010', color: '#801010' },
      { name: 'Blender', icon: 'https://cdn.simpleicons.org/blender/F5792A', color: '#F5792A' },
      { name: 'Lumion', lettermark: 'LM', color: '#A5C40E' },
      { name: 'Twinmotion', lettermark: 'TW', color: '#FF6E00' },
      { name: 'Unreal Engine', icon: 'https://cdn.simpleicons.org/unrealengine/0E1128', color: '#0E1128' },
      { name: 'V-Ray', icon: 'https://cdn.simpleicons.org/chaos/E60000', color: '#E60000' },
      { name: 'Enscape', lettermark: 'EN', color: '#3DB54A' },
    ],
  },
];

// Flat helper for places that need a single sliding strip
export const allSoftware = softwareCategories.flatMap((c) => c.items);
